import React, { useState } from "react";
import { Link } from "react-router-dom";
import { slugToCountryPathname } from "../../utils/strings";
import ContainerCard from "./containerCard";
import { ArrowRight } from "@speedoc/design-assets/build/icons/index.js";
import { useMediaQuery } from "react-responsive";
import CrossfadeImage from "react-crossfade-image";
import { orderBy } from "lodash";
import { LazyLoadImage } from "react-lazy-load-image-component";

const ServiceShowCases = ({ content }) => {
  const isMobile = useMediaQuery({ query: "(max-width: 992px)" });
  const [selectedImage, setSelectedImage] = useState(content?.defaultImage?.url ?? "");
  let services = isMobile ? orderBy(content.services, "mobileOrder", "asc") : content.services;

  return (
    <div
      id="serviceShowcases"
      className="full-width"
      style={content?.backgroundImage?.url ? { backgroundImage: `url(${content.backgroundImage.url})` } : {}}>
      <div className="centralContainer">
        <div className="content">
          <p className="upperTitle">{content.title}</p>
          {content.subtitle && <div className="subtitle" dangerouslySetInnerHTML={{ __html: content.subtitle }} />}
          {content.partners?.length > 0 && (
            <div className="partners">
              <div className="partnersCaption" dangerouslySetInnerHTML={{ __html: content.partnersCaption }} />
              {content.partners.map((element, index) => (
                <LazyLoadImage key={index} src={element.media?.url} alt="logo" effect="blur" />
              ))}
            </div>
          )}
          <div className="services">
            {services.map((element, index) => (
              <Link key={index} to={slugToCountryPathname(element.link)}>
                <ContainerCard className="serviceContainerCard">
                  <div className="serviceCard" onMouseOver={() => setSelectedImage(element?.image?.url)}>
                    <img className="icon" src={element?.icon?.url} alt="logo" />
                    <div className="content">
                      <p className="title">{element.title}</p>
                      <p className="subtitle">{element.subtitle}</p>
                      <div className="link">
                        <div className="price" dangerouslySetInnerHTML={{ __html: element.price }} />
                        <ArrowRight className="arrow right" />
                      </div>
                    </div>
                  </div>
                </ContainerCard>
              </Link>
            ))}
          </div>
          <p className="description">{content.description}</p>
        </div>
        {!isMobile && (
          <div className="phone">
            <CrossfadeImage src={selectedImage} />
            <img className="screenshot" src={content?.frame?.url ?? ""} alt="app" />
          </div>
        )}
      </div>
    </div>
  );
};

export default ServiceShowCases;
